<script>
    import Button, { Group, GroupItem, Label, Icon } from "@smui/button";
    import { get, writable } from "svelte/store";
    import API from "../../API/API";
    import Feature from "../../Branding/Feature";
    import User from "../../Branding/User";
    import Vessel from "../../Models/Vessel";
    import CommentForm from "./Form.svelte";
    import CommentView from "./CommentView.svelte";
    import Comment from "../../Models/Comment";
    import CommentVisibility from "../../Models/Enums/CommentVisibility";
    import { createEventDispatcher, onMount } from "svelte"
    import AppStore from "../../AppStore";
    import Tooltip from "../Tooltip.svelte";
    import AdminStore from "../Admin/Store";
    import AuthStore from "../../Auth/Store";
    import CompanyStore from "../Dashboards/Company/Store";
    
    export let vessel = writable(new Vessel());
    export let thread = null;
    export let confirmDialog = null; 
    const dispatch = createEventDispatcher(); // cancel

    let lastUpdated = thread.lastUpdated;

    onMount(()=>{
        API.get("comments/" + thread.id)
            .then((results) => {
                // TODO: do this better.
                thread.removeAllComments();
                for(let i = 0; i < results.comments.length; i++) {
                    thread.addComment(new Comment(results.comments[i]));
                }
                thread = thread;
                $lastUpdated = Date.now();
            });
    });

    $: {
        $lastUpdated;
    }
    
    let newReplyVisible = false;
    let startNewReply = (threadId) => { 
        newReplyVisible = true; 
    };
    let cancelAll = () => { 
        newReplyVisible = false;
    };
    
    let setThreadVisibility = (vis) => {
        API.put("comments/" + thread.id + "/visibility", {
            "visibility": vis
        }).then((results)=>{
                // console.log(results);
                thread.setVisibility(results.thread.visibility);
                thread = thread;
                $lastUpdated = Date.now();
            })
            .catch((err)=>{
                console.error(err);
            });
    };
    
    let toggleBoolState = (property) => {
        return new Promise((resolve, reject) => {
            let newVal = 0;
            if (thread[property] === 0) { 
                newVal = 1; 
            } 
            else if (thread[property] === 1) { 
                newVal = 0; 
            }
            API.put("comments/" + thread.id + "/state", {
                [property]: newVal
            })
                .then((results)=>{
                    thread.setLocked(results.thread.locked);
                    thread.setRemoved(results.thread.removed);
                    thread = thread;
                    $lastUpdated = Date.now();
                    resolve();
                })
                .catch((err)=>{
                    console.error(err);
                    reject(err);
                });

        });
    }
    let canLockAndDelete = () => {
        return  User.hasAnyOfFeatures([Feature.ADMIN.EDIT, Feature.ADMIN.COMMENTS.EDIT]) || 
                User.getCurrentUser().id == thread.user_id;
                //User.hasFeature(Feature.COMMENTS.EDIT) || 
    };
    let toggleLockState = () => {
        toggleBoolState("locked");
    }
    let canSetVisibility = () => {
        return User.hasAnyOfFeatures([Feature.ADMIN.EDIT, Feature.ADMIN.COMMENTS.EDIT]);
    };
   
    let deleteThread = () => {
        // TODO: confirmDialog={confirmDialog}
        if (confirmDialog) {
            confirmDialog.onConfirm = () => {
                toggleBoolState("removed")
                    .then(()=>{
                        dispatch("delete");
                    })
                    .finally(()=>{
                        confirmDialog.visible.set(false);            
                    })
            };
            confirmDialog.visible.set(true);
        }
        else {
            toggleBoolState("removed")
                .then(()=>{
                    dispatch("delete");
                });
        }
       
    }
    let onBack = () => {
        dispatch("cancel");
    }

    // ^AG: We need a way of determining if we're in the CMS.  
    // This is hacky but it works and doesn't involve passing context everywhere.
    let defaultPrivateVis = CommentVisibility.PROTECTED;
    let cmsVisible = AdminStore.cms.visible;
    let companyDashboardVisible = CompanyStore.dashboard.meta.visible;
    $: {
        $lastUpdated;
        defaultPrivateVis = CommentVisibility.PROTECTED;
        
        // console.log(thread, $cmsVisible, $companyDashboardVisible);

        if ($cmsVisible) {
            let company = AdminStore.helpers.getCompanyById(thread.companyId);
            defaultPrivateVis = company.defaultThreadVisibility;
        }
        if ($companyDashboardVisible) {
            let company = get(AuthStore.session.company);
            defaultPrivateVis = company.defaultThreadVisibility;
        }

        // console.log("defaultPrivateVis", defaultPrivateVis);

    }
    
    
</script>
<style>
    
    #vessel-thread .msg { 
        background-color: #eee;
    }
    #vessel-thread p.thread-title {
        font-weight: bold;
        font-size:14px;
        line-height:22px;
        padding:0px;
        margin:0px;
        margin-bottom:5px;
    }
   
</style>

<div id='vessel-thread'>
    {#if thread.removed === 0}
        <Button on:click={onBack} fullwidth color="secondary" variant="unelevated" class="bg-info" style='margin-bottom:10px;width:100%;'>
            <Label>Back</Label>
        </Button>
        <div class="msgbox mb-10 msg oa">
            <div class="oa">
                <p class='thread-title fl'>Thread: {thread.readableTitle}</p>
                
                {#if thread.visibility === CommentVisibility.PUBLIC}
                    <p class='thread-title fr'>
                        <Tooltip text={thread.visibilityDescription}>
                            {thread.visibilityName}
                        </Tooltip>
                    </p>
                {/if}
                {#if thread.locked}
                    <p class='thread-title fr' style="cursor:default;">
                        <Tooltip text={"Locked"}>
                            <span class="material-icons" style="line-height:16px;font-size:16px;">lock</span>
                        </Tooltip>
                    </p>
                {/if}
                
            </div>
            <!-- ... Add who owns it. Who started it. What its privacy is if relevant. etc. -->
            {#each thread.comments as comment, index}
                <CommentView 
                    comment={comment} 
                    index={index}
                    confirmDialog={confirmDialog}
                    on:delete={(e)=>{
                        // comment.id
                        thread.removeCommentById(comment.id);
                        thread = thread;
                        $lastUpdated = Date.now(); 
                        AppStore.snackbar.start("Comment deleted successfully!", "success");
                    }}
                />
            {/each}
            {#if thread.locked === 0}
                {#if newReplyVisible}
                    <CommentForm 
                        vessel={vessel} 
                        threadId={thread.id} 
                        on:cancel={cancelAll} 
                        on:success={(e)=>{ 
                            thread.addComment(new Comment(e.detail.comment));
                            thread = thread;
                            newReplyVisible = false;
                            $lastUpdated = Date.now(); 
                            AppStore.snackbar.start("Comment added successfully!", "success");
                        }} />
                {:else}
                    <Button on:click={startNewReply} fullwidth color="secondary" variant="unelevated" style='margin-top:0px;width:100%;'>
                        <Label>Add Reply</Label>
                    </Button>
                {/if}
            {/if}
            {#if canLockAndDelete()}
                <Button on:click={()=>{ toggleLockState(); }} fullwidth color="secondary" variant="unelevated" class="bg-warning" style='margin-top:5px;width:100%;'>
                    <Label>
                        {#if thread.locked === 0}Lock
                        {:else}Unlock{/if} Thread
                    </Label>
                </Button>
                <Button on:click={()=>{ deleteThread(); }} fullwidth color="secondary" variant="unelevated" class="bg-error" style='margin-top:5px;width:100%;'>
                    <Label>Delete Thread</Label>
                </Button>
                <p style="display:none;">{$lastUpdated}</p>
            {/if}
            {#if canSetVisibility()}
                <p><b>Visibility</b></p>
                <div class='oa'>
                    <Button on:click={()=>{ setThreadVisibility(CommentVisibility.PUBLIC); }} fullwidth color="secondary" variant="unelevated" class="bg-info fl" style='width:49%;margin-right:1%;' disabled={thread.visibility === CommentVisibility.PUBLIC}>
                        <Label><Tooltip text={CommentVisibility.toDescription(CommentVisibility.PUBLIC)}>{CommentVisibility.toName(CommentVisibility.PUBLIC)}</Tooltip></Label>
                    </Button>
                    <!-- ^AG: We may need to set it to CommentVisibility.PRIVATE, depending? If it's a classified client with that as the default set. 
                            It's not yet implemented. See this file: -->
                    <Button on:click={()=>{ setThreadVisibility(defaultPrivateVis); }} fullwidth color="secondary" variant="unelevated" class="bg-info fl" style='margin-left:1%;width:49%;margin-right:0;' disabled={thread.visibility === defaultPrivateVis}>
                        <Label><Tooltip text={CommentVisibility.toDescription(defaultPrivateVis)}>{CommentVisibility.toName(defaultPrivateVis)}</Tooltip></Label>
                    </Button>
                </div>
                <p style="display:none;">{$lastUpdated}</p>
            {/if}
            <p style="display:none;">{$lastUpdated}</p>
        </div>
    {/if}
</div>